//동아리 카드 UI (이미지, 동아리명, 간단 설명, 모집 상태)
import React from "react";
import { useNavigate } from "react-router-dom";
import "./ClubCard.css";

const PLACEHOLDER_COLOR = 'rgba(234, 234, 234, 0.73)';

function parseCategories(category) {
  if (!category) return [];
  if (Array.isArray(category)) return category;
  try { return JSON.parse(category); } catch { return [category]; }
}

function ClubCard({ club }) {
  const navigate = useNavigate();
  const { id, name, recruitment_status, description, image_url, category, member_count } = club;
  const isRecruiting = recruitment_status === "모집 중";
  const categories = parseCategories(category);

  return (
    <div className="home-club-card" onClick={() => navigate(`/clubs/${id}`)}>
      <div className="home-club-image-wrap">
        {image_url ? (
          <img src={image_url} alt={name} className="home-club-img" />
        ) : (
          <div
            className="home-club-img-placeholder"
            style={{ backgroundColor: PLACEHOLDER_COLOR }}
          >
            {name}
          </div>
        )}
        <span className={`home-club-badge ${isRecruiting ? 'badge-open' : 'badge-closed'}`}>
          {isRecruiting ? '모집 중' : '모집 종료'}
        </span>
      </div>

      <div className="home-club-body">
        <h4 className="home-club-name">{name}</h4>
        <p className="home-club-desc">{description}</p>
        <div className="home-club-footer">
          <div className="home-club-tags">
            {categories.slice(0, 2).map((cat) => (
              <span key={cat} className="home-club-tag">{cat}</span>
            ))}
          </div>
          {member_count > 0 && (
            <span className="home-club-members">멤버 {member_count}명</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ClubCard;
